import { PointsAccountingException } from '@/domain/points/accounting/exception/PointsAccountingException'

export class CouldNotGetBalanceException extends PointsAccountingException {

}
